import React from "react";

import { PrimaryButton } from "../Button";
import { WizardState } from "./WizadState";
import { WizardStep } from "./WizardLayout";

export interface WelcomeStepProps {
  state: WizardState<any>;
  imageUrl?: string;
  whatReady: "profile" | "workspace";
  headingId?: string;
  stepTestId?: string;
  startTestId?: string;
}

export function WelcomeStep({ state, whatReady, headingId, stepTestId, startTestId }: WelcomeStepProps) {
  const resolvedHeadingId = headingId ?? defaultHeadingId(whatReady);

  return (
    <WizardStep
      testId={stepTestId}
      footer={
        <PrimaryButton onClick={state.next} testId={startTestId}>
          Let's get started
        </PrimaryButton>
      }
    >
      <div className="flex flex-col items-center text-center mx-auto pt-8 pb-4 px-4">
        <div className="text-6xl mb-2 select-none" aria-hidden="true">
          🚀
        </div>
        <div className="mt-6 max-w-lg text-content-base space-y-4 text-left">
          <h1 className="font-semibold text-xl" id={resolvedHeadingId}>
            You're in. Let's build something great. 🎉
          </h1>
          <p>
            Welcome to your command center — the one place where the big goals and the everyday grind finally pull in
            the same direction.
          </p>
          <p>
            No busywork, no dashboards to babysit. Just you, your team, and a clear view of what actually moves the
            needle.
          </p>
          <p>Now go run the table — one win at a time. 💪</p>
        </div>
      </div>
    </WizardStep>
  );
}

function defaultHeadingId(whatReady: WelcomeStepProps["whatReady"]) {
  if (whatReady === "workspace") {
    return "company-creator-onboarding-heading";
  }

  return "company-member-onboarding-heading";
}
